export default "__VITE_ASSET__BsI4fbM$__"